import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import ModuleQuestion from "../../components/ModuleQuestion";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.4.6 Practice Case 4
            </h1>
            <p className="me-4">Estimated time to complete: 5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="A"
            assessmentName="practice_case_4"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                </p>
                <p>
                  This is Practice Case Number 4. This is a positive scan. When
                  you first load the image, it is immediately clear that there
                  is faint uptake throughout the brain. This is because the
                  images have been scaled to a very intense area within the
                  field of view, but not located within the brain. As you can
                  see on the coronal images, intense uptake is seen in the
                  salivary glands. This has scaled the images in the MIM Cloud
                  Viewer and may have done something similar on your own viewing
                  station. In order to ensure accurate interpretation, utilize
                  the contrast adjustment tool located here. While holding down
                  the right mouse button, include a field of view that includes
                  not only the brain, but the area surrounding the brain. Once
                  the contrast is adjusted, re-click on the arrow and start at
                  the bottom of the brain. As you can see, there is intense
                  uptake in the salivary glands bilaterally. Moving superiorly,
                  you can also see intense uptake in the posterior aspect of the
                  head. This activity is located within the scalp. Even more
                  superiorly is focal uptake, located in the posterior aspect of
                  the brain. This may confuse the reviewer with uptake in the
                  occipital lobe. Therefore, it is important to review the
                  accompanying CT images. As can be seen from the CT images,
                  this focal uptake is within the bone or, more accurately, most
                  likely within the bone marrow.
                </p>
                <p>
                  Returning to the PET-only images and scrolling superiorly, we
                  enter into the cerebellum, where normal gray-white contrast
                  can be seen. If there is concern for location, you can always
                  utilize the accompanying sagittal and coronal images to ensure
                  that you are, in fact, within the cerebellum. Again moving
                  superiorly, we enter into the temporal and occipital lobes. It
                  is immediately clear that there is loss of gray- white
                  contrast in the temporal and occipital lobes bilaterally. In
                  addition, white matter tracts are not easily identifiable.
                  This pattern is seen throughout the temporal and occipital
                  lobes as we continue moving upwards. Therefore, this scan is
                  positive for loss of gray-white contrast in these regions. As
                  we enter the frontal lobes, again you can see that there is
                  loss of gray-white contrast and poor delineation of the white
                  matter tracts bilaterally.
                </p>
                <p>
                  Again moving upwards and entering into the parietal lobes, the
                  white matter tracts are not easily identifiable, moving from
                  the front of the brain to the back on either side. In
                  addition, there is loss of gray-white contrast in the
                  posterior parietal region and, as we move superiorly, in the
                  lateral parietal region. As we continue to examine the top of
                  the brain, there remains loss of gray-white contrast
                  bilaterally. To recap, there is loss of gray-white contrast in
                  the temporal, occipital, frontal, and parietal regions.
                  Therefore, this scan is positive indicating moderate to
                  frequent amyloid neuritic plaques.
                </p>
              </>
            }
            previousLesson="/module-2/module-2-4-5"
            nextLesson="/module-2/module-2-4-7"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_556923838&entry_id=1_c7vwsljr&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="practice"
            videoId="1_c7vwsljr"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
